import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-company-identifier',
  templateUrl: './company-identifier.component.html',
  styleUrls: ['./company-identifier.component.css']
})
export class CompanyIdentifierComponent implements OnInit {

  imagePath = "";
  logoUrl = "";
  companyIdentfierForm : FormGroup =  new FormGroup({
    companyIdentfier:new FormControl('', {validators: [Validators.required, Validators.pattern('[a-zA-Z0-9]*')], updateOn: 'blur'})
  })

  get companyIdentfier() {
    return this.companyIdentfierForm.get('companyIdentfier');
  }
  constructor(private router: Router) { }

  ngOnInit(): void {
    this.imagePath = "/assets/tcb-circle-star.svg";
    this.logoUrl = "/assets/tcb-logo-oneline-blue.svg"
  }

  onSubmit(){
    if(this.companyIdentfierForm.valid) {
      this.router.navigate([`/employee-benefit/products`]);
    }

  }

}
